import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class DenominacionCuenta extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        const { data, codigoNovedad } = this.props;
        const { getFieldProps, getFieldError } = this.props.form;
        const { funcionesDelUsuario, seEstaEditando } = this.props.dataCompleto;

        let me = this;
        let errors;
        let errorContainer;
        let props = this.props;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputdenominacionCuenta')) ? errors.join(',') : null}</label>

        let error = (getFieldError('inputdenominacionCuenta')) ? true : false

        //////////Novedad en denominacion Cuenta////////////
        let denominacion = props.data.CuentaDenominacion;
        let novedaddenominacionCuenta = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedaddenominacionCuenta = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == codigoNovedad);
            if (novedaddenominacionCuenta != undefined) {
                const esNovedadEditadadenominacion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == codigoNovedad).editado;
                if (esNovedadEditadadenominacion == false) {
                    denominacion = novedaddenominacionCuenta.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////

        let componente = <div>
            <GenericInputValidate
                getFieldProps={getFieldProps('inputdenominacionCuenta', {
                    onChange(e) {
                        me.changeInput(e);
                    },
                    rules: [{
                        required: true,
                        pattern: /^[^~,]*$/,
                        message: 'Debe ingresar una denominación válida.'
                    }]
                })}
                id="inputdenominacionCuenta"
                name="inputdenominacionCuenta"
                value={denominacion}
                className="form-control default-input"
                autoComplete="off"
            />
            {errorContainer}
        </div>

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                error={error}
                permisoUsuario={funcionesDelUsuario}
                novedad={novedaddenominacionCuenta}
                seEstaEditando={seEstaEditando}
                textPanel={denominacion || "Sin especificar"}
                title="Denominación de la cuenta (para los archivos)"
                value={denominacion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedaddenominacionCuenta, 2, data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedaddenominacionCuenta, 3, data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}
export default DenominacionCuenta;